import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { RouteFilterService } from './Route-Filter.service';
import { PanelDetailLocationsService } from '../../locations-section/services/Panel-Detail-Locations.service';
import { PopupDetailGeoposService } from './Popup-Detail-Geopos.service';
import { environment } from "src/environments/environment";
import { MAP_MODULE_NAMES } from 'src/models/common/EnumMapas';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { EncriptionService } from 'src/app/features/shared/services/Encription.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';

@Injectable({
  providedIn: "root",
})
export class RouteMapService {
  
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(
    private sessionService:  SessionService,
    private mapHelperService: MapHelperService,
    private routeFilterService: RouteFilterService,
    private panelDetailLocationsService: PanelDetailLocationsService,
    private popupDetailGeoposService: PopupDetailGeoposService,  
    private localStorageService:  LocalStorageService, 
    private encriptionService:  EncriptionService
    ) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  hiddenRouteMapLayers(){
    this.mapHelperService.HideLayer("routeResume-steps-textlayer");
    this.mapHelperService.HideLayer("routeResume-line-layer");
    this.mapHelperService.HideLayer("routeResume-steps-layer");
    this.mapHelperService.HideLayer("routeResume-lineOpacityMin-layer");
    this.mapHelperService.HideLayer("routeStepsGroup-line-layer");
    this.mapHelperService.HideLayer("routeStepsGroup-steps-textlayer");
  }

  showRouteMapLayers() {
    this.mapHelperService.ShowLayer("routeResume-steps-textlayer");
    this.mapHelperService.ShowLayer("routeResume-line-layer");
    this.mapHelperService.ShowLayer("routeResume-steps-layer");
    this.mapHelperService.ShowLayer("routeResume-lineOpacityMin-layer");
    this.mapHelperService.ShowLayer("routeStepsGroup-line-layer");
    this.mapHelperService.ShowLayer("routeStepsGroup-steps-textlayer");
  }

  updateRouteMap(result: string) {
   // Actualiza capa de Puntos Inicio y Fin
   this.mapHelperService.UpdateLayerGeoJson( "routeResume", JSON.parse(result) );
   this.mapHelperService.UpdateLayerGeoJson( "routeResumeOpacityMin", JSON.parse(result) );
  }

  deleteRoutesData() {
    this.mapHelperService.UpdateLayerGeoJson("routeResume-steps-textlayer",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeResume-line-layer",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeResume-lineOpacityMin-layer",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeGroupStep",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeResume",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeResumeOpacityMin",this.mapHelperService.Empty_GeoJson);
  }





  LoadRouteMap() {
    // this.mapHelperService._map.on("load", () => {
      // this._map.loadImage("/assets/img/pinGeoposition.png", (error, image) => {
      //   if (error) throw error;
      //   if (!this._map.hasImage("pinGeoposition"))
      //     this._map.addImage("pinGeoposition", image, { sdf: true });
      // });
      this.mapHelperService._map.loadImage("/assets/img/starting.png", (error, image) => {
        if (error) throw error;
        if (!this.mapHelperService._map.hasImage("starting"))
          this.mapHelperService._map.addImage("starting", image, { sdf: false });
      });
      this.mapHelperService._map.loadImage("/assets/img/parking.png", (error, image) => {
        if (error) throw error;
        if (!this.mapHelperService._map.hasImage("parking"))
          this.mapHelperService._map.addImage("parking", image, { sdf: false });
      });
      this.mapHelperService._map.loadImage("/assets/img/moving.png", (error, image) => {
        if (error) throw error;
        if (!this.mapHelperService._map.hasImage("moving"))
          this.mapHelperService._map.addImage("moving", image, { sdf: false });
      });
      this.mapHelperService._map.loadImage("/assets/img/reporting.png", (error, image) => {
        if (error) throw error;
        if (!this.mapHelperService._map.hasImage("reporting"))
          this.mapHelperService._map.addImage("reporting", image, { sdf: false });
      });

      // const current = this.sessionService.loadedMapComponents.value;
      // this.sessionService.loadedMapComponents.next([...current, MAP_MODULE_NAMES.Routes]);
      this.addViewAsLoadedToStorage();
      this.initializeMapRoutes();

      this.mapHelperService.AddLayerEvent("click", "routeResume-steps-layer", (e) => {
        var obj: any = e.features[0].properties;
        if(!environment.production) console.log("Objeto Clicked");
        if(!environment.production) console.log(e.features[0]);
        this.popupDetailGeoposService.setVisibilityPopup(true);
        this.popupDetailGeoposService.setData(e.features[0].properties);
        this.popupDetailGeoposService.setTitle(e.features[0].properties._Id);
        this.popupDetailGeoposService.setLastUpdate(
          e.features[0].properties._CreatedIn
        );
        this.routeFilterService.GetDirection(
          e.features[0].properties._Longitude,
          e.features[0].properties._Latitude
        ).subscribe(direction => {
          this.popupDetailGeoposService.setAddress(direction);
          this.panelDetailLocationsService.setAddress(direction);
        });
      });

      //   _map.on("click", "startEndPoints-layer", (e) => {
      //     var obj: any = e.features[0].properties;
      //     if(!environment.production) console.log("Objeto Clicked");
      //     if(!environment.production) console.log(obj);
      //     this.popupDetailGeoposService.setVisibilityPopup(true);
      //     this.popupDetailGeoposService.setData(e.features[0].properties);
      //     this.popupDetailGeoposService.setTitle(e.features[0].properties._Id);
      //     this.popupDetailGeoposService.setLastUpdate(e.features[0].properties._CreatedIn);
      //     this.GetDirection(e.features[0].properties._Longitude,e.features[0].properties._Latitude);
      // });
    // });
  }

  initializeMapRoutes() {
    // this.AddSourceEmptyGeoJson("points");
    // this.AddSourceEmptyGeoJson("route");
    this.mapHelperService.AddSourceEmptyGeoJson("routeResume", "Resumen de ruta", 'annotation-line-bold.png');
    this.mapHelperService.AddSourceEmptyGeoJson("routeGroupStep", "Grupo de pasos de ruta", 'annotation-line.png');
    this.mapHelperService.AddSourceEmptyGeoJson("routeResumeOpacityMin", "Fondo de línea de resumen de ruta", 'annotation-line-low-opacity.png');
    // this.AddSourceEmptyGeoJson("startEndPoints");
    // this.AddSourceClusteredEmptyGeoJson("LastGeoPositions");
    this.mapHelperService.AddBaseMapSatellite();
    this.mapHelperService.AddLayerTextH3WithStatus(
      "routeResume-steps-textlayer",
      "routeResume",
      "Id",
      "Etiqueta de resumen de ruta"
    );
    // this.AddLayerTextH3("routeStepsGroup-steps-textlayer", "routeResume","Id");
    this.mapHelperService.AddLayerLine("routeResume-line-layer", "routeResume", "Línea de resumen de ruta");
    this.mapHelperService.AddLayerLineBold("routeStepsGroup-line-layer", "routeGroupStep", "Línea de grupo de pasos");
    this.mapHelperService.AddLayerLineOpacityMin(
      "routeResume-lineOpacityMin-layer",
      "routeResumeOpacityMin",
      "Fondo de línea de resumen de ruta"
    );
    this.mapHelperService.AddLayerSteps("routeResume-steps-layer", "routeResume", "Pasos de la ruta");
    // this.AddLayerGeoPoints("points-layer", "points");
    // this.AddLayerStartEndPoints("startEndPoints-layer", "startEndPoints");
    this.mapHelperService.ShowHideLayer("satellite-layer");
    this.mapHelperService.ShowHideLayer("satellite-layer");
    this.mapHelperService.ShowHideLayer("routeResume-lineOpacityMin-layer");
  }
 
  addViewAsLoadedToStorage(){
    const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    if (mapLoadedViewsEnc == null) {
      return;
    }
    
    const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
    if (decrypted == null) {
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify([MAP_MODULE_NAMES.Routes])) );
      this.sessionService.loadedMapComponents.next([MAP_MODULE_NAMES.Routes]);
      return;
    }
    
    var arr: any[] = [];
    try {
      const parsed = JSON.parse(decrypted);
      arr = parsed;
    } catch (e) {
      arr = [];
    }
    
    const key = MAP_MODULE_NAMES.Routes;
    if (!arr.includes(key)) {
      arr.push(key);
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify(arr)) );
      this.sessionService.loadedMapComponents.next(arr);
    }
  }
}
